module.exports = {
	"base": {
		"welcome": "Bienvenue à Mulligans, %{name} !",
		"user": "Informations sur les utilisateurs",
		"devices": "Périphériques",
		"refunds": "Remboursements",
		"resources": "Ressources",
		"transactions": "Commandes et retours",
		"email": "Courriel",
		"password": "Mot de passe",
		"save": "Enregistrer",
		"sign-out": "Se déconnecter",
		"cancel": "Annuler",
		"close": "Fermer",
		"learn-more": "En savoir plus",
		"required": "Obligatoire",
		"support": "Assistance",
		"bookshelf": "Bibliothèque",
		"launch": "Lancement",
		"download": "Télécharger",
		"details": "Détails",
		"cannot-be-blank": "%{field} ne peut être vide.",
		"saving": "Enregistrement...",
		"done": "Terminé",
		"failed": "Échec",
		"copy": "Copier"
	},
	"signin": {
		"login-failure": "Courriel ou mot de passe incorrect",
		"welcome-large": "Bienvenue <span class='inner'>au centre de comptes de %{brand}</span>",
		"welcome-small": "<span class='inner'> Centre de comptes </span>",
		"signin-button": "Se connecter",
		"forgot-password": "Mot de passe oublié?",
		"new-to-vst": "Nouveau pour %{brand}?",
		"create-account": "Créer un compte",
		"signing-in": "Connexion...",
		"signin-failed": "Échec de connexion"
	},
	"transactions": {
		"price": "Prix",
		"excluded": "(Hors taxes)",
		"quantity": "Quantité",
		"confirmation#": "Confirmation n °",
		"payment": "Paiement",
		"purchased": "Acheté",
		"purchase-details": "Détails d'achat",
		"subtotal": "Sous-total",
		"total": "Total",
		"tax": "Taxe",
		"loading": "Hey le grand gaspilleur, vos transactions sont en cours de chargement...",
		"no-purchases": "Vous n'avez aucun achat.",
		"seller-vat": "TVA du fournisseur",
		"total-vat": "%{vat} totale payée",
		"portion": "%{subTax} % des taxes %{rate}",
		"vat-disclosure": "Prix TTC %{vat}",
		"purchases": "Achats",
		"refunded-items": "Articles remboursés",
		"book-title": "Titre du livre",
		"refund-details": "Détails de remboursement",
		"print-receipt": "Imprimer le reçu",
		"request-refund": "Demander le remboursement",
		"expired": "Expiré",
		"expires-in": "Expire le %{date}",
		"details-refund": "Détails et remboursement",
		"modal": {
			"cant-refund-title": "Remboursement non disponible",
			"cant-refund": "Votre livre ne peut pas être remboursé pour l'une ou plusieurs des raisons suivantes.",
			"cant-refund-1": "Beaucoup trop de votre livre a été vu.",
			"cant-refund-2": "Plus de 14 jours se sont écoulés depuis la date d'achat.",
			"cant-refund-3": "Votre code de ressources en ligne a été révélé.",
			"cant-refund-4": "Votre livre a été précédemment remboursé.",
			"cant-refund-5": "Tous les codes ont déjà été rachetés et/ou remboursés.",
			"cant-refund-6": "Plus de 30 jours se sont écoulés depuis la date d'achat.",
			"cant-refund-support": "Si vous n'êtes toujours pas sûr de la politique de remboursement de %{brand}, communiquer <a href='%{support_url}' target='_blank'>avec le service de soutien à la clientèle </a>."
		},
		"license": {
			"perpetual": "L'accès en ligne n'expire pas",
			"days": "%{days} jours d'accès"
		}
	},
	"devices": {
		"description": "%{brand} vous permet d'avoir des ordinateurs <span>%{desktop}</span> et des appareils mobiles/tablettes <span>%{mobile}</span> activées à tout moment.",
		"loading": "Hey, nous vérifions vos appareils :)",
		"no-active": "Vous n'avez pas d'appareils activés.",
		"deactivate": "Désactiver"
	},
	"user": {
		"personal-information": "Données personnelles",
		"security-information": "Informations sur la sécurité",
		"notifications": "Notifications",
		"first-name": "Prénom",
		"last-name": "Nom",
		"change-password-title": "Changer de mot de passe",
		"current-password": "Mot de passe actuel",
		"new-password": "Nouveau mot de passe",
		"security-password": "Mot de passe",
		"confirm-new-password": "Confirmer le nouveau mot de passe",
		"security-question": "Question de sécurité",
		"security-info-change": "Modifier",
		"question": "Question",
		"answer": "Réponse",
		"notifications-text": "Envoyez-moi des mises à jour occasionnelles sur des activités sur mon compte, des mises à jour de produits et des offres spéciales.",
		"loading": "Spot est entrain de chercher vos informations utilisateur, patientez une un seconde 🐶",
		"change-password-text": "Le mot de passe doit comprendre au moins 8 caractères, une lettre majuscule, une lettre minuscule et un caractère spécial.",
		"email-locked": "Adresse courriel verrouillée",
		"email-locked-description": "Vous n'êtes pas autorisé à modifier votre courriel.",
		"email-locked-more": "Veuillez contacter votre administrateur.",
		"security-question6": "Quelle est votre sport préféré?",
		"security-question7": "Quelle est votre saveur préférée en matière de crème glacée?",
		"security-question8": "Quel est le nom de votre animal préféré?",
		"security-question9": "Quand vous étiez jeune, que vouliez-vous faire lorsque vous seriez plus grand?",
		"security-question10": "Quel était le nom de famille de votre enseignant préféré?",
		"new-password-failure": "Le mot de passe ne répond pas aux exigences",
		"confirm-password-failure": "Les mots de passe doivent être identiques",
		"new-password-tooltip": "Doit avoir 8 caractères au moins, une lettre majuscule, une lettre minuscule et un caractère spécial.",
		"enter-valid-email": "Veuillez saisir une adresse courriel valide.",
		"password-cannot-be-same": "Le mot de passe ne peut pas être le même que le mot de passe précédent",
		"incorrect-password": "Mot de passe incorrect",
		"complete-account": "On dirait que vous avez besoin de <a href='%{href}'>compléter votre compte</a>.",
		"completing-allows": "Le fait de compléter votre compte vous permet de lire des livres en mode hors ligne sur nos applications mobiles et de partager des notes et des surlignes avec des amis.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Accessoires",
		"access-codes": "Codes d'accès",
		"print-on-demand": "Impression à la demande",
		"check-pod": "Vérifiez les options d'impression Publisher pour vos livres.",
		"check-now": "Vérifier maintenant",
		"loading": "Patientez, nous mettons à jour vos ressources!",
		"in": "dans",
		"access-code-intro": "Un code d'accès est un mot de passe que vous utilisez pour accéder au contenu du cours en ligne. Une fois que vous révélez un code pour un article, vous ne serez pas en mesure de le retourner. Pour de plus amples informations sur la façon d'utiliser votre code d'accès, veuillez visiter <a href='%{support_url}' target='_blank'>le service d'assistance</a>.",
		"expires": "Expire le",
		"expiration-message": "Comprend les instructions nécessaires pour utiliser votre code d'accès.",
		"copy-fail": "Impossible de copier. Veuillez sélectionner le code et le copier manuellement.",
		"launch-site": "Lancer le site",
		"launch-book": "Lancement du livre",
		"reveal-code": "Révéler le code",
		"no-resources": "Vous n'avez aucune ressource.",
		"no-access-codes": "Vous ne disposez pas de codes d'accès.",
		"no-ancillaries": "Aucun article auxilaire pour ce titre",
		"name": "Nom",
		"type": "Type",
		"size": "Taille",
		"download-all": "Télécharger tout",
		"back": "Retour aux ressources"
	},
	"refunds": {
		"states": {
			"refunded": "Remboursé",
			"unavailable": "Remboursement non disponible"
		},
		"reasons": {
			"dropped": "J'ai abandonné le cours",
			"wrong": "C'était le mauvais livre pour mon cours",
			"print": "J'ai décidé d'acheter la version imprimée à la place",
			"missing": "Le livre ne comprend pas tout ce dont j'ai besoin pour mon cours (par exemple, un CD, l'accès au Web, vidéos)",
			"other": "Autre"
		},
		"bulk": {
			"policy": "En cliquant sur le bouton « Remboursement intégral » ci-dessous, j'accepte la politique de remboursement de %{brand} <a href='%{policy_url}' target='_blank'>.</a>.",
			"complete": "Remboursement intégral",
			"view-details": "Afficher les détails de remboursement",
			"success": "Votre remboursement a été demandé. Veuillez attendre 48 heures pour le traitement.",
			"failure": "Oops - une erreur s'est produite! Malheureusement, votre remboursement n'a pas été effectué.",
			"retry": "Essayez à nouveau",
			"support": "Communiquer avec le service technique",
			"available-codes": "Codes disponibles",
			"codes-selected": "Codes sélectionnés",
			"download": "Télécharger des codes",
			"partially-refunded": "Partiellement remboursé",
			"pick-one": "Vous devez sélectionner au moins un code pour effectuer un remboursement"
		},
		"refund": "Remboursement",
		"all": "Tout rembourser?",
		"missing-reason": "Vous devez sélectionner une raison pour continuer",
		"missing-elaboration": "Veuillez préciser",
		"policy": "En cliquant sur le bouton « Remplir la demande de remboursement » ci-dessous, je comprends que si j'achète ce manuel électronique de %{brand} encore une fois, je ne serai pas admissible à demander d'autres remboursements pour le même manuel électronique. Voir la politique complète en matière de remboursement.",
		"refunded": "Remboursé",
		"sorry": "Nous sommes désolés que vous n'étiez pas satisfait de votre achat.",
		"error": "Une erreur s'est produite. ",
		"error-explain": "Imppossible de traiter votre remboursement. Veuillez réessayer.",
		"why": "Pourriez-vous nous dire pourquoi?",
		"no-refunds": "Vous n'avez pas d'articles remboursés.",
		"select-codes": "Sélectionnez le(s) code(s) à rembourser :",
		"number": "Combien?",
		"back": "Retour aux remboursements"
	},
	"purchases": {
		"back": "Retour aux achats"
	},
	"global-bar": {
		"account": "Paramètres de compte"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/fr-CA.json
 ** module id = 1007
 ** module chunks = 0
 **/